import {baseConfig} from '../helpers/baseConfig'
import {BRAND_LABEL} from '../../../../brand'

export const cardConfig = (props) => {
    const isRegistered = props?.isCustomerRegistered
    const email = props?.customerEmail
    return {
        ...baseConfig(props),
        clickToPayConfiguration: {
            merchantDisplayName: BRAND_LABEL,
            shopperEmail: email,
        },
        showPayButton: true,
        hasHolderName: true,
        holderNameRequired: true,
        billingAddressRequired: false,
        enableStoreDetails: isRegistered,
    }
}
